import React from "react";
import {Col, Container, Row} from "react-bootstrap";

const storiesgcc = () => {
  return (
    <div className="normal_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Take a Glimpse of Our Mobile App Development Success Stories </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
            TekRevol, a global mobile app development company, excels in next-gen mobile app development, propelling businesses worldwide. We have proved our credibility with our high-tech solutions serving different business industries. With pure determination and an innovative approach, we have achieved this mark. Therefore, we take pride in presenting our proven solutions as you can explore our case studies below:
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default storiesgcc;
